import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GifSettingsFrameRate',
  props: {
    value: null,
    disabled: { type: Boolean },
    maxFrameRate: null,
    frameRates: null,
    id: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: number;
  disabled?: boolean;
  maxFrameRate: number;
  frameRates: Array<number>;
  id: string;
}





const inputValue = computed({
  get() {
    return props.value;
  },
  set(value: number) {
    emits("input", value);
  }
});

return { __sfc: true,props, emits, inputValue }
}

})